import React, { useEffect, useRef } from "react";
import { gl_start, turnY, mxm, perspective, setUniform, inverse, scale } from './webgl5.js';

export default function WebGLCanvas() {

  // OCTAHEDRON DEFINED AS 8 TRIANGLES

/*
   Note that to animate the mesh we
   need to transform both the position
   and the normal, and that means we
   need to pass both the matrix and
   the inverse matrix down to the GPU.
*/

function Scene() {

this.mesh = {
  data: new Float32Array([
  -1, 0, 0,-1,-1,-1,  0,-1, 0,-1,-1,-1,  0, 0,-1,-1,-1,-1,
   1, 0, 0, 1,-1,-1,  0,-1, 0, 1,-1,-1,  0, 0,-1, 1,-1,-1,

  -1, 0, 0,-1, 1,-1,  0, 1, 0,-1, 1,-1,  0, 0,-1,-1, 1,-1,
   1, 0, 0, 1, 1,-1,  0, 1, 0, 1, 1,-1,  0, 0,-1, 1, 1,-1,

  -1, 0, 0,-1,-1, 1,  0,-1, 0,-1,-1, 1,  0, 0, 1,-1,-1, 1,
   1, 0, 0, 1,-1, 1,  0,-1, 0, 1,-1, 1,  0, 0, 1, 1,-1, 1,
   
  -1, 0, 0,-1, 1, 1,  0, 1, 0,-1, 1, 1,  0, 0, 1,-1, 1, 1, // second face - flipped on x
   1, 0, 0, 1, 1, 1,  0, 1, 0, 1, 1, 1,  0, 0, 1, 1, 1, 1, // first face
  ])
};

this.vertexShader = `\
#version 300 es
uniform mat4 uMF, uMI;

in  vec3 aPos, aNor;
out vec3 vPos, vNor;

void main() {
  vec4 pos = vec4(aPos, 1.0);
  vec4 nor = vec4(aNor, 0.0);

  pos = uMF * pos; // multiply on the right
  nor = nor * uMI; // multiply on the left

  gl_Position = pos * vec4(1.,1.,-1.,1.);

  vPos = pos.xyz;
  vNor = nor.xyz;
}`;

this.fragmentShader = `\
#version 300 es
precision highp float;

in  vec3 vPos, vNor;
out vec4 fragColor;

void main() {
   vec3 nor = normalize(vNor);
   float c = .1 + max(0., dot(vec3(.5),nor));
   fragColor = vec4(c, c, c, 1.0);
}`;

let startTime = Date.now()/1000;

this.update = () => {
   let time = Date.now() / 1000 - startTime;
   let m = mxm(perspective(0, 0, -0.5),
           mxm(turnY(time),
	       scale(.5)));
   setUniform('Matrix4fv', 'uMF', false, m);
   setUniform('Matrix4fv', 'uMI', false, inverse(m));
}
}

  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const scene = new Scene();
    gl_start(canvas, scene);

    return () => {
      if (canvas.stopRender) canvas.stopRender();
    };
  }, []);

  return (
    <div style={{ display: "flex", justifyContent: "center", gap: "4px" }}>
      <canvas ref={canvasRef} width={400} height={400}
        style={{ width: "400px", height: "400px", display: "block", margin: "0 auto", background: "black" }} />
        <pre className = "codeblock-shader">{ Scene.toString() }</pre>
    </div>
  );
}